class ChatbotEvents {
  private static instance: ChatbotEvents;

  private subscribers: Array<(isVisible: boolean) => void> = [];

  private constructor() {}

  public static getInstance(): ChatbotEvents {
    if (!ChatbotEvents.instance) {
      ChatbotEvents.instance = new ChatbotEvents();
    }
    return ChatbotEvents.instance;
  }

  public subscribe(callback: (isVisible: boolean) => void): () => void {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((cb) => cb !== callback);
    };
  }

  public setChatbotVisibility(isVisible: boolean): void {
    this.subscribers.forEach((callback) => callback(isVisible));
  }
}

export default ChatbotEvents.getInstance();
